export const DOLLAR_PATTERN = /^(\d+)(?:\.(\d{1,2}))?$/;
export const WHOLE_NUMBER_PATTERN = /^\d+$/;
export const MAX_GRAPHQL_INT = 2_147_483_647;
